export default {
  car: 'modelGroup',
};
